<template>
  <v-layout
    row
    wrap>
    <links-app/>
    <v-flex xs12>
      <span style="font-size: 11px; font-weight: 500">
        &copy;
        {{ (new Date()).getFullYear() }}

        <a
          href="https://esteiogestao.com.br/"
          target="_blank">Esteio Gestão Agropecuária</a>
      </span>
    </v-flex>
    <v-flex xs12>
      <span>
        {{ (idioma === 0) ? 'Todos os direitos reservados' : 'All rights reserved' }}
      </span>
    </v-flex>
  </v-layout>
</template>
<script>
import {
  mapState
} from 'vuex'
import LinksApp from './LinksApp'
export default {
  components: {
    LinksApp
  },
  computed: {
    ...mapState('app', ['strings', 'idioma', 'user']),
    heightOverflow () {
      return 'margin: 0; padding: 20px; max-height: ' + String(this.$vuetify.breakpoint.height) + 'px; overflow: auto;'
    }
  }

}
</script>
